import { render, staticRenderFns } from "./TrainingSection.vue?vue&type=template&id=24f89eec&"
import script from "./TrainingSection.vue?vue&type=script&lang=js&"
export * from "./TrainingSection.vue?vue&type=script&lang=js&"
import style0 from "./TrainingSection.vue?vue&type=style&index=0&id=24f89eec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports